import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import DescriptionComponent from './description.component';
import PersonComponent from './person.component';
import { lineHeight, responsiveFontSize } from 'style';

const DescriptionPlusContactlistComponent = ({
    id,
    descriptionLabel,
    descriptionBody,
    contactPerson,
}) => (
    <div className="wrapper" id="DescriptionPlusContactlistComponent">
        <div className="container-fluid">
        <div className="row">
            <div className="col-xs-12 col-lg-3">
                <DescriptionComponent
                    descriptionLabel={descriptionLabel}
                    descriptionBody={descriptionBody}
                />
            </div>
            <div className="col-xs-12 col-lg-8 col-lg-offset-1">
                <div className="row">
                    {contactPerson.map(person => (
                        <div
                            key={`${id}${person.name}`}
                            className="col-xs-6 col-md-3 col-lg-3"
                            >
                            <PersonComponent {...person} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </div>
    </div>
);

export default DescriptionPlusContactlistComponent;
